/**
 * interaction/facades/diagnostic.facade.instance.js
 *
 * Production wiring — creates the diagnostic facade with real dependencies.
 * Import this from presentation code (step4-compliance.js, etc.)
 */

import { createDiagnosticFacade } from './diagnostic.facade.js';
import {
  compliance,
  algorithmOptimize,
  scoreEvaluate,
  revisionSuggest,
  generateRevised,
  pollListingGeneration,
} from '../../api/listing-api.js';
import * as diagnosticStore from '../stores/diagnostic.store.js';

export const diagnosticFacade = createDiagnosticFacade({
  compliance,
  algorithmOptimize,
  scoreEvaluate,
  revisionSuggest,
  generateRevised,
  pollListingGeneration,
  diagnosticStore,
});
